<script setup lang="ts">
import {ConsumerProduct} from "@/consumer/interfaces";
import ConsumerProductTreatmentRow
    from "@/interview/components/instance-modal/consumer-product-tracking/treatments/ConsumerProductTreatmentRow.vue";

defineProps<{
    consumerProducts: ConsumerProduct[];
}>();

const emit = defineEmits<{
    (e: 'openDosageDialog', product: ConsumerProduct): void;
}>();
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex">
      <h3>Traitements du patient</h3>
    </div>
    <ConsumerProductTreatmentRow
      v-for="(product, index) in consumerProducts"
      :key="product.id"
      :consumer-product="product"
      :index="index"
      @open-dosage-dialog="(_product) => emit('openDosageDialog', _product)"
    />
  </div>
</template>

<style scoped>

</style>
